Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Whimsical", {
  enumerable: true,
  get: function get() {
    return _whimsical.Whimsical;
  }
});
var _whimsical = require("./whimsical");